<template>
  <DecoratorState
    :hasTitleOnAdaptive="hasTitleOnAdaptive"
    title="New"
    :hasTitle="hasTitle"
    class="state-new"
  >
    <template #icon>
      <IconMaterial title="priority_high" size="16" class="state-new__icon" />
    </template>
  </DecoratorState>
</template>

<script>
  import DecoratorState from '@/uikitProject/decorators/DecoratorState';
  import IconMaterial from '@/uikitBase/icons/IconMaterial';

  export default {
    name: 'StateNew',

    components: {
      DecoratorState,
      IconMaterial,
    },

    props: {
      hasTitle: {
        type: Boolean,
        default: true,
      },
      hasTitleOnAdaptive: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .state-new {
    color: $color-text-third;
    font-weight: $weight-bold;

    &__icon {
      margin-right: -3px;
    }
  }
</style>
